import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './ToolPage.css'
import './Tournament.css'
import TournamentBoard from './TournamentBoard'
import {
  fetchTournamentState,
  tournamentStreamUrl,
  tournamentJoinUrl,
  recordTournamentResult,
} from './utils/tournamentApiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const FORMAT_LABELS = {
  league: 'Pontos corridos',
  knockout: 'Mata-mata',
  groups: 'Grupos + mata-mata',
}

const TournamentMaster = () => {
  useDocumentMeta({
    title: 'Campeonato ao Vivo, Mestre | jarder.dev',
    description: 'Alimente os placares e acompanhe a classificação ou o chaveamento avançar sozinho.',
  })

  const { id } = useParams()
  const masterToken = (/token=([^&]+)/.exec(window.location.hash) || [])[1] || ''

  const [state, setState] = useState(null)
  const [status, setStatus] = useState('loading')
  const [error, setError] = useState('')
  const [copied, setCopied] = useState(false)

  const joinUrl = tournamentJoinUrl(id)

  useEffect(() => {
    let cancelled = false

    fetchTournamentState(id)
      .then((data) => {
        if (cancelled) return
        setState(data)
        setStatus('ready')
      })
      .catch(() => {
        if (!cancelled) setStatus('notfound')
      })

    const eventSource = new EventSource(tournamentStreamUrl(id))
    eventSource.onmessage = (event) => {
      setState(JSON.parse(event.data))
    }

    return () => {
      cancelled = true
      eventSource.close()
    }
  }, [id])

  const submitResult = async (matchId, scoreA, scoreB) => {
    setError('')
    try {
      await recordTournamentResult(id, masterToken, matchId, scoreA, scoreB)
      trackEvent('tool_generate', { tool: 'tournament_result' })
    } catch (err) {
      setError(err.message || 'Não foi possível registrar o placar.')
    }
  }

  const copyJoinLink = () => {
    navigator.clipboard.writeText(joinUrl)
    setCopied(true)
    trackEvent('tool_copy', { tool: 'tournament' })
  }

  if (status === 'loading') {
    return (
      <div className="tool-page">
        <p>Carregando...</p>
      </div>
    )
  }

  if (status === 'notfound') {
    return (
      <div className="tool-page">
        <Link to="/ferramentas" className="tool-back-link">
          ← Todas as ferramentas
        </Link>
        <h1>Torneio não encontrado</h1>
        <p className="tool-disclaimer">Esse torneio não existe ou expirou.</p>
        <Link to="/ferramentas/campeonato-ao-vivo" className="tool-button">
          Criar um novo torneio
        </Link>
      </div>
    )
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Campeonato ao Vivo, Mestre</h1>
      <p className="tool-disclaimer">
        Essa tela é só sua. Compartilhe o link abaixo pra galera acompanhar.
        Formato: <strong>{FORMAT_LABELS[state.format]}</strong>.
      </p>

      <div className="tool-result-card">
        <span className="tool-result-label">Link pra acompanhar</span>
        <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
          {joinUrl}
        </span>
        <div className="tool-result-actions">
          <button type="button" className="tool-button tool-button-secondary" onClick={copyJoinLink}>
            {copied ? 'Copiado!' : 'Copiar link'}
          </button>
        </div>
      </div>

      {error && <p className="tool-error">{error}</p>}

      <TournamentBoard state={state} editable onSubmitResult={submitResult} />
    </div>
  )
}

export default TournamentMaster
